import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/react';
import { t } from '@lingui/macro';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useLocalisation } from '@3plearning/lingui-cdn';

// Components
import Table from '../table/table';
import MoveListBody from './move-list-body';
import EmptyDataMessage from '../empty-data-message/empty-data-message';

// Actions
import consoleActions from '../../containers/console/actions/console-actions';

// Helpers
import { stripCharacters } from '../../helpers/utils';

function MoveList(props) {
    const { i18n } = useLocalisation();

    const {
        studentsList,
        updateMoveStudentList,
        productId,
        // Action props
        getInitialStudentsForMoveCopy
    } = props;

    const [availableClasses, setAvailableClasses] = useState([]);

    useEffect(() => {
        let isCancelled = false;
        const fetchClasses = async () => {
            const newStudentsData = await getInitialStudentsForMoveCopy({
                productId
            });

            /*
                This list is independent of what class the teacher is in,
                it's dependent on the availableClasses which is class-agnostic
             */
            if (!isCancelled && newStudentsData) {
                setAvailableClasses(newStudentsData.classrooms);
            }
        };

        fetchClasses();

        return () => {
            isCancelled = true;
        };
    }, []);

    const [enhancedStudentsList, setEnhancedStudentsList] = useState(undefined);

    const allStudentsLine = {
        lastName: '',
        firstName: '',
        userProfileId: 0,
        groupId: 0
    };
    if (studentsList.length > 1 && !enhancedStudentsList) {
        studentsList.unshift(allStudentsLine);
        setEnhancedStudentsList(true);
    }

    // Number of students, count lines but ignore the "All students:" line
    const numberOfStudents = studentsList && studentsList.length > 1 && studentsList[0].userProfileId === 0 ?
        studentsList.length - 1 : studentsList.length;
    // Cell elements (header/body)
    const listOfHeaders = [
        {
            key: stripCharacters(i18n._(t`Header - Students`)),
            content: (
                <Trans id={'Header - Students with value - {numberOfStudents}'}>
                    value {numberOfStudents}
                </Trans>
            )
        },
        {
            key: stripCharacters(i18n._(t`Header - Actions`)),
            colSpan: 3,
            content: <Trans id={'Header - Actions'} />
        }
    ];

    const [isSelectAllInUse, setIsSelectAllInUse] = useState(false);
    const listOfRows = studentsList && studentsList.length > 0 ?
        studentsList.map(
            (row, index) => (
                <MoveListBody
                    key={`move-students-${row.userProfileId}`}
                    userId={row.userProfileId}
                    userGroupId={row.groupId}
                    index={index}
                    fullName={`${row.lastName}, ${row.firstName}`}
                    availableClasses={availableClasses}
                    updateMoveStudentList={updateMoveStudentList}
                    isSelectAllInUse={isSelectAllInUse}
                    setIsSelectAllInUse={setIsSelectAllInUse}
                />
            )
        ) :
        [
            (
                <EmptyDataMessage
                    key="emptyRow"
                    colSpan={4}
                />
            )
        ];

    return (
        <Table
            listOfHeaders={listOfHeaders}
            listOfRows={listOfRows}
        />
    );
}

MoveList.propTypes = {
    studentsList: PropTypes.arrayOf(PropTypes.object),
    updateMoveStudentList: PropTypes.func,
    productId: PropTypes.number,
    getInitialStudentsForMoveCopy: PropTypes.func
};

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from MessageModalCombinedReducers.
 */
function mapStateToProps(state) {
    const {
        productId
    } = state.consoleReducer;

    return {
        productId
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getInitialStudentsForMoveCopy: consoleActions.getInitialStudentsForMoveCopy
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MoveList);



// WEBPACK FOOTER //
// ./components/students-lists/move-list.js